<div class="banner-tick-wrapper">
    <div #number class="banner-tick"></div>

    <div #numberClone class="banner-tick"></div>
</div>
